import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { UserContext } from './../hooks/UserContext';

export default function PrivateRoute({children}) {
   const { user, isLoading } = useContext(UserContext);
   let location = useLocation();

   if (isLoading) {
       return <>Loading...</>
   }
   
   return user && user.role === 'admin' ? children : <Navigate to='/login' state={{ from: location }}/>

 }